import { useQuery } from "react-query";
import { AUTH_USER, GUEST_USER } from "../constants";
import { customerBusinessService } from "../services";

const getRewards = async () => {
    const response = await customerBusinessService.getMyRewards()
    return response.data.data;
};

export default function useGetRewards(customer_id: number, userType: string = AUTH_USER) {

    return useQuery<any>(
        ["myRewards", customer_id],
        () => getRewards(),
        {
            retry: false,
            enabled: userType !== GUEST_USER && !!customer_id,
            staleTime: Infinity,
            cacheTime: 1000 * 60 * 60, 
        }
    );
}
